/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { APIEndpoint,DFPAPIEndpoint } from "../../../utils/axios";
import { useLocation,useNavigate} from "react-router-dom";
import { FilterBodyTemplate } from "../../../utils/configs";
import { DataGrid,LoaderPop, NGODatePicker, Modal, EditModal} from "../../../common";
import {formatDateByTimezone} from '../../../utils/commonFunctions';
import { useTranslation } from 'react-i18next';
import { CashDepositDetailsModal } from "./cashDepositDetails";
import { CashDepositEditModal } from "./cashDepositEdit";
import { SectorSelect, getPendingSectors } from "./depositSectorCard"
import downloadMasterIcon from '../../../assets/icons/download-master.svg';
import editIcon from "../../../assets/edit.svg"
import deleteIcon from "../../../assets/icons/deleteRole.svg"
import moment from 'moment';
import usePermissions from '../../../utils/userPermissions';
import CustomSelect from '../../../common/CustomSelect';


const DepositSummaryColumns = [
  { field: 'currency',headerName: 'pages.cashRegisterContent.cashDeposits.summaryTableColumns.currency',flex:1,autoHeight: true,suppressSizeToFit:true},
  { field: 'value', headerName: 'pages.cashRegisterContent.cashDeposits.summaryTableColumns.value', suppressSizeToFit:true, flex:1,autoHeight: true},
]

const ActionButtons = [
  { title: "Edit", className: 'btn-info', action: 'edit' },
  { title: "Delete", className: 'btn-danger', action: 'delete' },
  { title: "Submit", className: 'btn-primary', action: 'submit' },
]


export const CashDepositsPage = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { t,ready } = useTranslation();
  const [state, setState] = useState({
    cashDrawerList: null, filterDate: '', filterState: null, filterCashDrawer: null,
    resetDataSource: false,denomId:location.state?.depositId||null
  });
  const [modalCustomButtons,setModalCustomButtons]=useState([]);
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const sType = localStorage.getItem('sType');
  const [isDropDownOpen,setIsDropdownOpen]=useState(false);
  const [ModalContHeight,setModalContHeight]=useState({height:'auto'});
  const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);

  const { hasPermission: createCashDrawer } = usePermissions('create', "cashier.collection");
  const { hasPermission: editCashDrawer } = usePermissions('edit', "cashier.collection");
  const { hasPermission: viewcashDrawer } = usePermissions('viewDetails', 'cashier.collection');
  const { hasPermission: savecashDrawer } = usePermissions('save', 'cashier.collection');
  const { hasPermission: deletecashDrawer } = usePermissions('delete', 'cashier.collection');
  const { hasPermission: downloadcashDrawer } = usePermissions('download', 'cashier.collection');


  const getStateList = () => {
    return [
      { key:0,label: t('pages.cashRegisterContent.cashDeposits.statePlaceHolder'), value: "" },
      { key:1,label: t('pages.cashRegisterContent.cashDeposits.stateDraft'), value: "draft" },
      { key:2,label: t('pages.cashRegisterContent.cashDeposits.stateFinalized'), value: "finalized" },
    ]
  }
  const NewDepositFields = [
    { label: 'Cash Drawer', attribute: 'cashDrawerId', type: 'selectSearch2', required: true ,cellStyle: {
      whiteSpace: 'nowrap',
      overflow:'hidden',
      textOverflow:'ellipsis',
    },},
    { label: 'Date', attribute: 'targetDate', type: 'date', required: true },
    { label: 'Employee', attribute: 'employeeId', type: 'multiSelect',required: true },
  ]

  const ReportFields = [
    { label: 'Report Type', attribute: 'reportType', type: 'selectSearch2', required: true },
    { label: 'Start Date', attribute: 'startDate', type: 'date', required: true,value:new Date(moment()),maxDate:new Date(moment())},
    { label: 'End Date', attribute: 'endDate', type: 'date', required: true ,value:new Date(moment()),maxDate:new Date(moment())},
  ]
  const [reportsFields, setReportFields] = useState(ReportFields||[]);


  useEffect(() => {
    fetchCashDrawersList();
  }, [t])

  useEffect(() => {
    if(isDropDownOpen){
      setModalContHeight({height:'55vh'})
    }else{
      setModalContHeight({height:'auto'})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isDropDownOpen]);

  useEffect(() => {
    if(state.selectedSector){
      getDisableState()
    }
    if(state.showActionDialog==='report'){
      setReportFields((prev)=>{
        return prev?.map((_) => {
          if(_.label ==='End Date'){
            return { ..._, minDate:new Date(ReportFields[1].value), }

          }
          else {
            return { ..._,}
          }
        })
      })
    }

  }, [state])


  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location, navigate]);


  useEffect(() => {
    const fetchCashData = async () => {
      if (state.denomId) {
        try {
          const cashDep = await fetchCashBalance(1, 4000, "");

          if (cashDep && cashDep.items) {
            const casDepObj = cashDep.items.find(c => c.id === state.denomId);
            if (casDepObj) {
              onAction(casDepObj, 'edit');
            }
          }
        } catch (error) {

        }
      }
    };
    fetchCashData();
  }, [state.denomId]);

  const onAction = (row, action) => {
    let data = row;
    switch (action) {
      case 'edit':
      case 'adddeposit': break;
      case 'delete':
      case 'submit':
      case 'summary':
      data.rows = (row.aggregate || []).map((_) => {
      return { currency: `${_.currencyName} (${_.currencyCode})`, value: _.value }
      })
      break;
      default:
      break
    }
    setState((_) => ({ ..._, showActionDialog: action, actionDialogData: { ...data }}))
  }
  const cellRenderer = (params) => {
    let state = Boolean(params && params.data) ? params.data.state : null;
    if (state) {
      return (
        <div className='flexCol'>
          {
            state === 'draft' ?
              <div className='flexRow actions'>
                {
                  ActionButtons.map((btn) => {
                    if (btn.title === "Edit") {
                      return (
                        <div className="alignItemsCenter icon-aircraft-container">
                          <img
                            className="aircraft-actions"
                            style={{margin:'0.4rem 0rem 0.4rem 0rem'}}
                            alt="edit"
                            onClick={() => onAction(params.data, btn.action)}
                            src={editIcon}
                          />
                          <span className="tooltip-action">Edit</span>
                        </div>
                      );
                    } else if (btn.title === "Delete") {
                      return (
                        <div className="alignItemsCenter icon-aircraft-container">
                          <img
                            className="aircraft-actions margBottom6"
                            alt="delete"
                            onClick={() => onAction(params.data, btn.action)}
                            src={deleteIcon}
                          />
                          <span className="tooltip-action">Delete Deposit</span>
                        </div>
                      );
                    } else {
                      return (
                        <button
                          key={btn}
                          className={`grid-download-btnStyle1`}
                          onClick={() => onAction(params.data, btn.action)}
                        >
                          <span>{btn.title}</span>
                        </button>
                      );
                    }
                  })
                }
              </div>
              :
            <div className='flexRow actions'>
              <button className='grid-download-btnStyle1'  onClick={() => onAction(params.data, 'details')}>
                <span>Details</span>
              </button>
            </div>
          }
        </div>
      )
    }
    return null;
  }

  function layoutComponent(props) {

    return (
      props.data && viewcashDrawer ?
      <div>
        <button className="grid-download-btnStyle1"  onClick={() => onAction(props.data, 'summary')}>View Summary</button>
      </div> : <div></div>
    );
  }
  const Columns = [
    { field: 'code', headerName: 'pages.cashRegisterContent.cashDeposits.tableColumns.code', resizable:true,
    suppressSizeToFit:true,minWidth:230,tooltipField: 'code',flex:1},
    { field: 'cashDrawerText', headerName: 'pages.cashRegisterContent.cashDeposits.tableColumns.cashDrawerText', resizable:true,flex:1,
    suppressSizeToFit:true,minWidth:160},
    { field: 'date', headerName: 'pages.cashRegisterContent.cashDeposits.tableColumns.date',
    suppressSizeToFit:true,flex:1,minWidth:90,width:100 },
    { field: 'crewName', headerName: 'pages.cashRegisterContent.cashDeposits.tableColumns.crewName',resizable:true,
    suppressSizeToFit:true,flex:1,minWidth:260 },
    { field: 'createdByName', headerName: 'pages.cashRegisterContent.cashDeposits.tableColumns.createdByName',resizable:true,
    suppressSizeToFit:true ,minWidth:260 },
    { field: 'createdAtText', headerName: 'pages.cashRegisterContent.cashDeposits.tableColumns.createdAtText',
    suppressSizeToFit:true},
    { field: 'stateText', headerName: 'pages.cashRegisterContent.cashDeposits.tableColumns.stateText',
    suppressSizeToFit:true,width:110,minWidth:100},
    {field:'',headerName:'pages.cashRegisterContent.cashDeposits.tableColumns.summary',pinned:'right',
    minWidth: 140,
    resizable:true,
    headerClass: 'actions-header',
    suppressSizeToFit:true,
    cellRenderer: layoutComponent,
    valueGetter: function(params) {
      return params.data;
    }
  },
  { field: '', headerName: 'pages.cashRegisterContent.cashDeposits.tableColumns.actions',pinned:'right',headerClass: 'actions-header', className: 'btn-view-report',resizable:true,
  suppressSizeToFit:true,minWidth: 160},
  ]
  const getColumns = () => {
    let columns = Columns.map((_) => ({ ..._ }));
    columns[columns.length - 1].cellRenderer = cellRenderer;
    return columns
  }
  const fetchCashDrawersList = async () => {
    try {
       const res = await APIEndpoint.get('cashRegister/cashDrawers');
    const list = (res.result || []).map((_,index) => ({ key:index, label: _.value ,value: _.id,}));
    const listDownloadBankTransfer = (res.result || []).map((_,index) => ({ key:index, label: _.value ,value: _.id,}));
    list.unshift({ label: t('pages.cashRegisterContent.cashDrawer.selectPlaceholder'), value: '' })
    listDownloadBankTransfer.unshift({ label: t('pages.cashRegisterContent.cashDrawer.selectPlaceholder'), value: '' })
    setState((_) => ({ ..._, cashDrawerList: list,cashDrawerDownload:listDownloadBankTransfer }))
    } catch (error) {

    }

  }
  const fetchCashBalance = async (iPageNo = 1, iPageLimit = 50, iSearchText = '') => {
    const filterData = JSON.parse(JSON.stringify(FilterBodyTemplate));
    filterData.page = iPageNo;
    filterData.limit = iPageLimit;
    filterData.searchParam = iSearchText;
    filterData.filters = [];
    if (state.filterDate) filterData.filters.push({ targetDate: moment(state.filterDate).toISOString() });
    if (state.filterState) filterData.filters.push({ state: state.filterState });
    if (state.filterCashDrawer) filterData.filters.push({ cashDrawerId: state.filterCashDrawer });

    const res = await APIEndpoint.post('cashRegister/deposits/listing', filterData);
    if (res.items) {
      const statuss = getStateList();
      res.items = res.items.map((_) => {
        const date = moment(_.createdAt);
        const state = statuss.find((s) => s.value === _.state)
        return {
          ..._,
          cashDrawerText: _.cashDrawer.airport.locationName,
          date: date.format("DD-MM-YYYY"),
          createdAtText: date.format("DD-MM-YYYY hh:mm a"),
          createdByName: `${_.createdBy.employeeName} (${_.createdBy.employeeCode})`,
          crewName: `${_.crew.employeeName} (${_.crew.employeeCode})`,
          stateText: state ? state.label : _.state
        }
      })
    }
    return res;
  }

  const handleFilterInput = (e) => {
    setState((_) => ({ ..._, [e.target.name]: e.target.value, resetDataSource: true }));
    let timerId = setTimeout(() => {
      clearTimeout(timerId);
      setState((_) => ({ ..._, resetDataSource: false }));
    }, 100)
  }
  function onChangeFilterSearchInput(val,name){
    setState((_) => ({ ..._, [name]: val?.value, resetDataSource: !state.resetDataSource }));
  }
  const handleModalCancel = () => {
    setState((_) => ({ ..._, showActionDialog: null, actionDialogData: null,showAPILoading:false }))
    setReportFields(ReportFields);
  }

  const handleAPI = async (apiCallback, onComplete) => {
    setState((prevState) => ({ ...prevState, showAPILoading: true }));
    try {
      await apiCallback()
        .then((res) => {
          setState((prevState) => ({...prevState,showAPILoading: false,resetDataSource: true,message: { success: true, message: res.message },}));
          setTimeout(() => {
            setState((prevState) => ({...prevState,showActionDialog: null,actionDialogData: null,message: null,resetDataSource: false,newDepositFormData: null,}));
            if (onComplete) onComplete(res);
          }, 1500);

          return res;
        })
        .catch((err) => {
          let errorMessage = '';
            const { data } = JSON.parse(err?.message);
            errorMessage = data?.message || errorMessage;
            setState((prevState) => ({...prevState,showAPILoading: false,message: { success: false, message: setModalFormStatusObj({ error: errorMessage }) },}));
          setTimeout(() => {
            setModalFormStatusObj({ text: "" });
            setState((prevState) => ({ ...prevState, message: null }));
          }, 1500);

          return null;
        });
    } catch (error) {
      setState((prevState) => ({ ...prevState, showAPILoading: false }));
      return null;
    }
  };

  const handleDelete = async () => {
    const { actionDialogData } = state;
    const apiCallback = () => {
      return APIEndpoint.post('cashRegister/deposits/delete/' + actionDialogData.id);
    }
    await handleAPI(apiCallback)
  }
  const handleSubmit = async () => {
    const { actionDialogData } = state;
    const apiCallback = () => {
      return APIEndpoint.post('cashRegister/deposits/finalize/' + actionDialogData.id);
    }
    await handleAPI(apiCallback)
  }
  const handleAddDeposit = async () => {
    await fetchCashDrawersList()
    const res = await APIEndpoint.get('sandboxing/employees')
    const list = (res.result || []).map((_,index) => ({ key:index,value: `${_.employeeId}`, label: `${_.employeeName}( ${_.employeeCode})` }));
    list.unshift({ label: t('pages.cashRegisterContent.cashDeposits.selectEmpPlaceholder'), value: '' })
    setModalCustomButtons([{label:'Create',attribute:'button',type:"button",disabled:true,className:'submit-button',action:'onSubmit'}])
    setState((_) => ({ ..._, showActionDialog: 'adddeposit', employeesList: list, pendingSectors: null }))
  }

    const handleOnchangeReports=(selectedValue,data,obj)=>{
      const {reportType}=data;
      if(reportType==="cashierBankTransferReport"){
      setReportFields((prev)=>{
      const cashDrawExist=prev.some(item=>item.attribute==='cashDrawer')
      if(!cashDrawExist){
      return [...prev,{ label: 'Select Station', attribute: 'cashDrawer', type: 'selectSearch2', required: true }]

      }else{
      return prev

      }

      }

      )
      }
      else{
        setReportFields((prev) => {
          return prev.map((field) => {
            if (field.attribute === 'startDate' && data.startDate) {
              return { ...field, value: new Date(data.startDate) };
            }
            if (field.attribute === 'endDate' && data.endDate) {
              return {
                ...field,value: new Date(data.endDate),minDate: new Date(data.startDate) || null};
            }
            if (field.attribute === 'endDate' && data.startDate && !data.endDate) {
              const startDate = new Date(data.startDate);
              const today = new Date();
              if (startDate <= today) {
                return {...field,value: today,minDate: startDate};
              } else {
                return {...field,value: startDate,minDate: startDate,
                };
              }
            }

            if (reportType !== "cashierBankTransferReport" && field.label === 'Select Station') {
              return null;
            }
            return field;
          }).filter(field => field !== null);
        });

      }
    }
  const handleAddDepositOnChange = async (selectedValue,data,obj) => {
    const {attribute ,name} = data;
    const value=selectedValue?.value
    if (attribute === 'employeeId' || (attribute||name) === 'targetDate') {
      const newDepositFormData = state.newDepositFormData || {}
      if((attribute||name) === 'targetDate'){    
        let formattedDate = null;
        if (data?.value) {
          const dateObj = new Date(data.value);
          if (!isNaN(dateObj.getTime())) {
            formattedDate = formatDateByTimezone(new Date(dateObj) , false);
          }
        }
        newDepositFormData[attribute||name]=formattedDate
      }
      else{
        newDepositFormData[attribute] = value;
      }
      setState((_) => ({ ..._, newDepositFormData: { ...newDepositFormData } }))

      if (newDepositFormData.employeeId && newDepositFormData.targetDate) {
        setState((_) => ({ ..._, pendingSectors: 'wait' }))
        try {
          const res = await getPendingSectors(newDepositFormData.employeeId, newDepositFormData.targetDate)
          if(res.success){
            setState((_) => ({ ..._, pendingSectors: res.sectors, selectedSector: {}, pendingSectorsError: '' }))
          }
        } catch (error) {
          setState((_) => ({ ..._, pendingSectors: [], selectedSector: {}, pendingSectorsError: error.data?.message }))
        }
      }else if(!newDepositFormData.employeeId && attribute === 'employeeId'){
        setState((_) => ({ ..._, pendingSectors: []}))
      }
    }
  }
  const getNewDepositFields = () => {
    const getOptions = (field) => {
      let options;
      switch (field) {
        case 'cashDrawerId': options = state.cashDrawerList; break;
        case 'employeeId': options = state.employeesList; break;
        default:break
      }
      return options
    }
    return NewDepositFields.map((_) => {
      return {
        ..._,
        options: getOptions(_.attribute)
      }
    })
  }
  const handleCreateDeposit = async (e, updated) => {
    let valid = NewDepositFields.every(field => {
      if (!updated[field.attribute]) {
        return false
      }
      return true
    })
    const selectedCount = Object.values(state.selectedSector || {}).filter((_) => _).length;
    if (valid && selectedCount > 0 && !state.showAPILoading) {
      const body = { ...updated }
      // body.employeeId = Number(body.employeeId);
      let emp_id = state.newDepositFormData.employeeId
      body.employeeId = Number(emp_id);
      body.targetDate = moment(body.targetDate).startOf('day')
      body.sectors = [];
      state.pendingSectors.forEach(({ aircraftNumber, storeId, flightDate, key }) => {
        if (state.selectedSector[key]) {
          body.sectors.push({
            aircraftNumber, storeId, flightDate
          })
        }
      })
      await handleAPI(() => APIEndpoint.post('cashRegister/deposits', body), (res) => onAction(res.cashDeposit, 'edit'))
    }
  }
  const handleDownloadReportBtn = async () => {
    let res = await APIEndpoint.get('reports/cashierReportTypes')
    const list = res.result.map(_ => ({ label: _.value, value: _.id }));
    list.unshift({ label: t('pages.cashRegisterContent.cashDeposits.cashReportPlaceholder'), value: "" })
    setState((_) => ({ ..._, showActionDialog: 'report', cashReportTypes: list }))
  }

  const handleDownloadReportSubmit = async (e, updated) => {
    updated={...updated,startDate:updated.startDate?updated.startDate:ReportFields[1].value,endDate:updated.endDate?updated.endDate:ReportFields[2].value}
   let valid = ReportFields.every((_) => {
      return updated[_.attribute]
    })
    if (valid) {
      setState((prevState) => ({
        ...prevState,
        showAPILoading: true,
      }));

        let body ={}
        if(!updated.cashDrawer){
         body= {
            endDate: formatDateByTimezone(new Date(updated.endDate),true),
            reportType: updated.reportType,
            startDate: formatDateByTimezone(new Date(updated.startDate),true),
          }
        }else{
          body= {
            endDate: formatDateByTimezone(new Date(updated.endDate),true),
            reportType: updated.reportType,
            cashDrawerId:updated.cashDrawer,
            startDate: formatDateByTimezone(new Date(updated.startDate),true),
          }
        }
  let header={
        'Accept':'text/csv'
      }
     try {

            const res= await DOMAIN.post('cashier/download/' + body.reportType, body,header);

          if(res.status==='scheduled'){
            setTimeout(() => {
              const dowId = DOMAIN.get(`downloads/status/${res.id}`);
              dowId.then((val) => {
                if (val.status === "completed") {
                    DOMAIN.get(`downloads/analytics/${val.fileName}${val.fileExtension}`)
                        .then((ItemMasterDwnld) => {
                            const url = window.URL.createObjectURL(new Blob([ItemMasterDwnld]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', val.fileName + '.csv');
                            document.body.appendChild(link);
                            link.click();
                            setState((_) => ({ ..._,actionDialogData: null,showAPILoading:false }))
                        })
                        .catch((error) => {

                            console.error('Error downloading CSV:', error);
                        });

                }
            });
              }, 8000);
          }
          }
           catch (error) {
            setState((_) => {
              return { ..._,message:{text:error?.data?.message},};
            })
            setTimeout(() => {
              setState((prevState) => ({
                ...prevState,
                message: null,
                actionDialogData: null,showAPILoading:false
              }));
            }, 5000);
           }


    }

  }

  function getDisableState(){
    const disabledState = Object.keys(state.selectedSector).some(key=>state.selectedSector[key] === true);
    setModalCustomButtons([{label:'Create',attribute:'button',type:"button",disabled:!disabledState,className:'submit-button',action:'onSubmit'}])
  }


  return (
    <div className="flexCol width100 ag-theme-alpine-dark cash-reg">
      {
        state.cashDrawerList === null ?
          <LoaderPop/>
          :
          <>
            <div className='flexCol full-flex'>
              <DataGrid
                columnResize
                showDefaultFilters
                enableGridSearch
                className='full-flex'
                columns={getColumns()}
                getRows={fetchCashBalance}
                RightComponent={(props) => {
                  return (
                    <div className='flexRow alignItemsCenter'>
             {downloadcashDrawer?<span className='margTop11 margRight upload dropdownStyle1-TextMedium' onClick={handleDownloadReportBtn}><img title={"Download Reports"} className="icon-size"  style={{ width: '25px', height: '24px'}} alt='download' src={downloadMasterIcon} /></span>:<></>}
                      <CustomSelect
                        options={state.cashDrawerList}
                        placeHolder="Search Cash Drawer"
                        onChange={val=>onChangeFilterSearchInput(val,"filterCashDrawer")}
                        value={state.cashDrawerList.filter((data)=>{
                          return data.value === state.filterCashDrawer
                        })}
                      />
                      <div className='margLeft8'>
                        <CustomSelect
                          options={getStateList()}
                          placeHolder="Search State"
                          onChange={val=>onChangeFilterSearchInput(val,"filterState")}
                          value={getStateList().filter((data)=>{
                            return data.value === state.filterState
                          })}
                        />
                      </div>
                      <NGODatePicker
                        value={state.filterDate}
                        name='filterDate'
                        className='filter-cash'
                        onChange={handleFilterInput} />
                     { createCashDrawer?<button className="add-item-button margLeft8"
                        onClick={handleAddDeposit}>
                        {/* <i className='icon-plus add-icon' /> */}
                        {t('pages.cashRegisterContent.cashDeposits.addnewDepositBtn')}
                      </button>:<></>}
                    </div>
                  )
                }}
                resetDataSource={state.resetDataSource}
                onButtonCellClick={(e, field, row) => {
                  onAction(row, 'summary');
                }}
              />
            </div>
          </>
      }
      {
        state.showActionDialog === 'summary' && viewcashDrawer &&
        <Modal
          title={`${t('pages.cashRegisterContent.cashDeposits.depositSummart')}${state.actionDialogData.code}`}
          onSubmit={handleModalCancel}
          onClose={handleModalCancel}>
          <DataGrid
            columnResize
            showDefaultFilters={false}
            enableGridSearch={false}
            className='full-flex'
            rowModelType='clientSide'
            columns={DepositSummaryColumns}
            rowData={state.actionDialogData.rows}
          />
        </Modal>
      }
      {
        state.showActionDialog === 'details' &&
        <CashDepositDetailsModal
          detail={state.actionDialogData}
          onClose={() => setState((_) => ({ ..._, showActionDialog: null, actionDialogData: null }))} />
      }
      {
        (state.showActionDialog === 'edit') && editCashDrawer &&
        <CashDepositEditModal
          detail={state.actionDialogData}
          onClose={() =>setState((_) => ({ ..._, showActionDialog: null,denomId:null}))} />
      }

      {
        state.showActionDialog === 'delete' && deletecashDrawer &&
        <Modal
          buttonLabel={t("Delete")}
          className='cash-deposit-summary'
          title={`${t('pages.cashRegisterContent.cashDeposits.deleteModalTitle')}${state.actionDialogData.code}`}
          onSubmit={handleDelete}
          modalFormStatusObj={modalFormStatusObj}
          showLoadingBtn={state.showAPILoading}
          onClose={handleModalCancel}>
          <div className='flexCol width100'>
            <div className='alert alert-warning'>
              {t('pages.cashRegisterContent.cashDeposits.deleteWarning')}
            </div>
            <DataGrid
              columnResize
              showDefaultFilters={false}
              enableGridSearch={false}
              className='full-flex'
              rowModelType='clientSide'
              columns={DepositSummaryColumns}
              rowData={state.actionDialogData.rows}
            />
            {
              Boolean(state.showAPILoading) &&
              <LoaderPop />
            }
            {
             Boolean(state.message) && Boolean(state.message.message) &&
              <div className={`alert alert-${state.message.success ? 'success' : 'danger'}`}>
                {state.message.message}
              </div>
            }
          </div>
        </Modal>
      }
      {
        state.showActionDialog === 'submit' && savecashDrawer &&
        <Modal
          buttonLabel={t("Submit")}
          className='cash-deposit-summary'
          title={`${t('pages.cashRegisterContent.cashDeposits.submitModalTitle')}${state.actionDialogData.code}`}
          onSubmit={handleSubmit}
          modalFormStatusObj={modalFormStatusObj}
          showLoadingBtn={state.showAPILoading}
          onClose={handleModalCancel}>
          <div className='flexCol width100'>
            <div className='alert alert-warning'>
              {t('pages.cashRegisterContent.cashDeposits.submitWarning')}
            </div>
            <DataGrid
              columnResize
              showDefaultFilters={false}
              enableGridSearch={false}
              className='full-flex'
              rowModelType='clientSide'
              columns={DepositSummaryColumns}
              rowData={state.actionDialogData.rows}
            />

            {
              Boolean(state.message) &&  Boolean(state.message.message) &&
              <div className={`alert alert-${state.message.success ? 'success' : 'danger'}`}>
                {state.message.message}
              </div>
            }
          </div>
        </Modal>
      }
      {
        state.showActionDialog === 'adddeposit' &&
        <EditModal
          showDone={false}
          className='cash-sector-add'
          showFieldsInColumn={true}
          title={t('pages.cashRegisterContent.cashDeposits.addnewDepositModalTitle')}
          fields={getNewDepositFields()}
          onSubmit={handleCreateDeposit}
          customContentHeight={ModalContHeight}
          setIsDropdownOpen={setIsDropdownOpen}
          modalFormStatusObj={modalFormStatusObj}
          showLoadingBtn={state.showAPILoading}
          onClose={handleModalCancel}
          modalCustomButtons={modalCustomButtons}
          onChange={handleAddDepositOnChange}>
          <div className='flexCol justifyContentSpaceEvenly '>
            <SectorSelect
              label='Sectors'
              sectors={state.pendingSectors}
              selected={state.selectedSector}
              onSelect={(key) => {
                setState((_) => ({ ..._, selectedSector: { ...state.selectedSector, [key]: !Boolean(state.selectedSector[key]) } }))
              }}
              placeholder={state.pendingSectorsError || t('pages.cashRegisterContent.cashDeposits.addDepositSectorPlaceholder')}
            />
          </div>


        </EditModal>
      }
      {
        state.showActionDialog === 'report' &&reportsFields.length&&
        <EditModal
          showDone={false}
          className='cash-sector-add'
          showFieldsInColumn={true}
          modalFormStatusObj={modalFormStatusObj}
          onChange={handleOnchangeReports}
          showLoadingBtn={state.showAPILoading}
          title={t('pages.cashRegisterContent.cashDeposits.downloadReportTitle')}
          fields={reportsFields?.map((_) => {
            if(_.label!=='Select Station'){
              return { ..._, options: state.cashReportTypes, initialValue: '' }

            }
            else {
              return { ..._, options: state.cashDrawerDownload, initialValue: '' }
            }
          })}
          onSubmit={handleDownloadReportSubmit}
          onClose={handleModalCancel}>
        </EditModal>
      }
      {
      !ready &&<div className='overlay_hide sub'></div>
      }
    </div>
  )
}